import { handleFormatStyleString } from "@/components/package-components/utils";
import { DetailsVariantsProps } from "../props";
import { VehicleDetailsVariant1 } from "./pre-owned/01";
import { SendGTMEvents } from "../send-gtm-events";
import { VehicleDetailsVariant2 } from "./pre-owned/02";
import { BrandNewVehicleDetailsVariant1 } from "./brand-new/01";

export default function DetailsVariants({
  props,
  vehicle,
  vehiclePrice,
  variant,
}: DetailsVariantsProps) {
  const is0KM = vehicle?.vehicleZeroKMOutput ? true : false;

  function renderDetails() {
    switch (variant) {
      case 1:
        return (
          <VehicleDetailsVariant1
            props={props}
            variant={variant}
            vehicle={vehicle}
            vehiclePrice={vehiclePrice}
            {...props}
          />
        );
      case 2:
        return (
          <VehicleDetailsVariant2
            props={props}
            variant={variant}
            vehicle={vehicle}
            vehiclePrice={vehiclePrice}
            {...props}
          />
        );
      default:
        return (
          <VehicleDetailsVariant1
            props={props}
            variant={variant}
            vehicle={vehicle}
            vehiclePrice={vehiclePrice}
            {...props}
          />
        );
    }
  }

  const handle0KMDetails = () => {
    switch (variant) {
      case 1:
        return (
          <BrandNewVehicleDetailsVariant1
            props={props}
            variant={variant}
            vehicle={vehicle}
            vehiclePrice={vehiclePrice}
            {...props}
          />
        );

      default:
        return (
          <BrandNewVehicleDetailsVariant1
            props={props}
            variant={variant}
            vehicle={vehicle}
            vehiclePrice={vehiclePrice}
            {...props}
          />
        );
    }
  };

  return (
    <>
      {props && props.styles && props.styles.value && (
        <style>
          {handleFormatStyleString(props.styles.value as string, props.id)}
        </style>
      )}

      <SendGTMEvents vehicle={vehicle} />

      {is0KM ? handle0KMDetails() : renderDetails()}
    </>
  );
}
